/* eslint-disable no-unused-vars */
import store from "@/store";
import { ForgeMessage } from "@/utils/forgeMessageUtils";
import { getJSON } from '@/utils/mongoUtils';
import jQuery from 'jquery';

export function onNewTestBlindMarkupCreated(markupId) {
    //Build Markup Data
    var testBlindData = {
        ForgeMarkupID: markupId,
    }

    var attachment = store.getters['getActiveAttachment'];
    var testBlindOptions = store.getters['getTestBlindData'];
    var currentPageNumber = store.getters['getActiveAttachmentPage']

    let page = attachment.pagesMarkups.find(o => o.pageId == currentPageNumber);

    //Assign blind Markup attribute
    testBlindData.ForgeAttachmentID = attachment.id;
    testBlindData.ForgeMarkupPageID = page.id;  
    testBlindData.MarkupTypeAbbreviation = testBlindOptions.abbreviation;
    testBlindData.MarkupType = testBlindOptions.name;
    testBlindData.Size = testBlindOptions.size;
    testBlindData.FlangeType = testBlindOptions.type;
    testBlindData.Rating = testBlindOptions.rating;
    testBlindData.Thickness = testBlindOptions.thickness;
    testBlindData.pageNumber = currentPageNumber ? currentPageNumber : 1;
    
    var sequences = store.state.MARKUPS.nextTestBlindSequence
    var sequence = sequences[testBlindOptions.name]?.sequence ?? 1;
    testBlindData.Sequence = sequence;

    //Save test blind data to state untill the user clicks save, 
    //Then they will be passed to Origin
    store.state.MARKUPS.testBlindsToBeAdded.push(testBlindData);
}

export function addNewBlindMarkupsToOrigin() {
    //01. Get state testBlindsToBeAdded
    var blindsToAdd = store.state.MARKUPS.testBlindsToBeAdded;
    var blindsToDelete = store.state.MARKUPS.testBlindsToBeDeleted;
    var attachment = store.getters['getActiveAttachment'];
    
    if(blindsToAdd.length < 1 && blindsToDelete.length < 1) {
        return;
    }
    
    //Make sure sequence is retrived from Origin
    //03. loop over testBlindsToBeAdded
    for(let i = 0; i < blindsToAdd.length; i++) {
        var blind = blindsToAdd[i];
        var blindPageNumber = blind.pageNumber;
        let page = attachment.pagesMarkups.find(o => o.pageId / 1 == blindPageNumber / 1);
        if(page == null) return;
        //04. Set ForgeMarkupPageID
        blind.ForgeMarkupPageID = page.id;

        //05. Delete pageNumber Property
        delete blind.pageNumber;

        //06. Set each markup sequence entity
        //Done just after edit mode close
    }

    //07. Save Blinds to Origin
    let messageTitle = "add-test-blind-list";
    let addMessageData = JSON.stringify(blindsToAdd);
    let addForgeMessage = new ForgeMessage(messageTitle, addMessageData);
    addForgeMessage.send();

    messageTitle = "delete-test-blind-list";
    let deleteMessageData = JSON.stringify(blindsToDelete);
    let deleteForgeMessage = new ForgeMessage(messageTitle, deleteMessageData);
    deleteForgeMessage.send();

    store.state.MARKUPS.testBlindsToBeAdded = [];
    store.state.MARKUPS.testBlindsToBeDeleted = [];
    
    return true;
}

export async function getPipingDrawings(moduleUrl, testPackageId) {
    var pipingDrawingsUrl = `${moduleUrl}/odata/DocumentOutputFilePage?
    $expand=DocumentOutput($expand=DocumentClassContent($expand=DocumentClass)),DocumentRevisionFilePage($expand=DocumentRevision($expand=Document))
    &$filter=DocumentOutput/TestPackageID eq ${testPackageId} and 
    DocumentRevisionFilePage/IsDeleted eq false and 
    DocumentOutput/IsDeleted eq false and 
    DocumentOutput/DocumentClassContent/IsDeleted eq false and 
    DocumentOutput/DocumentClassContent/DocumentClass/IsDeleted eq false and 
    IsDeleted eq false`;

    pipingDrawingsUrl = pipingDrawingsUrl.replace(/(\r\n|\n|\r)/gm, "");
    pipingDrawingsUrl = pipingDrawingsUrl.replaceAll('    ', '');
    var pipingDrawings = await getJSON(pipingDrawingsUrl, '', null);

    if(!pipingDrawings || !pipingDrawings.value || pipingDrawings.value?.length < 1) {
        return [];
    }

    var originForgeLinksUrl = `${moduleUrl}/odata/ForgeLink?$filter=ContextID eq ${testPackageId}`;
    var originForgeLinks = await getJSON(originForgeLinksUrl, '', null);

    if(originForgeLinks && originForgeLinks.value && originForgeLinks.value?.length < 1) {
        originForgeLinks.value = [];
    }

    var documentsData = pipingDrawings.value.map(x => {
        var documentClass = x.DocumentOutput?.DocumentClassContent?.DocumentClass;
        var document = x.DocumentRevisionFilePage?.DocumentRevision?.Document;
        var documentRevision = x.DocumentRevisionFilePage?.DocumentRevision;
        var documentPageNumber = x.DocumentRevisionFilePage?.PageNumber;
        var link = originForgeLinks.value.find(o => o.TargetID == x.ID);
        var name = link?.LinkName ?? x.DocumentRevisionFilePage?.FileNameWithoutExtension;
        var doc = {
            "name": name,
            "controller": "documentrevisionfilepage",
            "DocumentOutputFilePageID": x.ID,
            "DocumentNumber": document.Number,
            "DocumentFileName": x.DocumentRevisionFilePage?.FileNameWithoutExtension,
            "PageNumber": documentPageNumber,
            "RevisionNumber": documentRevision?.RevisionNumber,
            "DocumentClassName": documentClass?.Name,
            "DocumentClassID": documentClass?.ID,
            "DocumentOutputID": x.DocumentOutput?.ID,
            "DocumentRevisionFilePageID": x.DocumentRevisionFilePage?.ID,
            "TestPackageID": testPackageId,
            "AbsolutePath": x.DocumentRevisionFilePage?.AbsolutePath,
        }
        doc.id = x.ID;

        return doc
    });
    return documentsData;
}

export async function getAllPipingDocuments(moduleUrl, testPackageId){
    var pipingDrawings = await getPipingDrawings(moduleUrl, testPackageId);

    if(pipingDrawings.length > 0) {
        //Group Documents by DocumentClassName
        pipingDrawings = pipingDrawings.reduce((array, element) => {
            const { DocumentClassName } = element;
            var group = array.find(o => o.id == element.DocumentClassName) ?? [];
            var isExisting = group && group.length > 0;
            group.name = element.DocumentClassName;
            group.id = element.DocumentClassName;
            group.push(element)
            if(isExisting) {
                var index = array.indexOf(group)
                array[index] = (group);
            } else {
                array.push(group)
            }
            return array;
        }, []);
    }
    pipingDrawings = pipingDrawings.map((group)=>{
        var linkClass = {
            items: [...group],
            id: group.id,
            name: group.name,
        }
        return linkClass;
    })
    return pipingDrawings;
}

export function getPipingDrawingLinkUrl(moduleApiUrl, odataController, linkData) {
    var revisionFilePageId = null;
    var pdfUrl ='';
    if(!linkData) {
        return null;
    }
    var parentId = linkData.DocumentOutputFilePageID;
    var url = `${moduleApiUrl}/odata/DocumentOutputFilePage?$filter=id eq ${parentId}`;
    jQuery.ajax({
        url: url,
        contentType: false,
        processData: false,
        async: false,
        type: "GET",
        success: function (response) {
            if(!response || !response.value || !response.value.length > 0) {
                return '';
            }
            revisionFilePageId = response.value[0]?.DocumentRevisionFilePageID;
            pdfUrl = revisionFilePageId ? getFilePathSas(moduleApiUrl, odataController, revisionFilePageId) : null;
        },
        error: function (data) {
            console.error(data);
        }
    });
    return pdfUrl;
}

export function getFilePathSas(moduleApiUrl, odataController, fileID) {
    var documentUrl;
    jQuery.ajax({
        url: `${moduleApiUrl}/odata/${odataController}/GetSasWithID?key=${fileID}`,
        contentType: false,
        processData: false,
        async: false,
        type: "GET",
        success: function (data) {
            documentUrl = data;
        },
        error: function (data) {
            console.error(data);
        }
    });
    documentUrl = `${window.location.origin}/blob${documentUrl}&format=.pdf`;
    return documentUrl;
}